import React, { useEffect, useState } from "react";
import "./styles/HubArenasPopup.css";

const HUB_URL = "https://hubarenas.com";
const COUNTDOWN_START = 20;

export default function HubArenasPopup() {
  const [count, setCount] = useState(COUNTDOWN_START);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          window.location.href = HUB_URL;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleRedirect = () => {
    window.location.href = HUB_URL;
  };

  return (
    <div className="hub-overlay" aria-modal="true" role="dialog">
      <div className="hub-bg-effects">
        <div className="hub-glow hub-glow-1" />
        <div className="hub-glow hub-glow-2" />
        <div className="hub-ring hub-ring-1" />
        <div className="hub-ring hub-ring-2" />
      </div>

      <div className="hub-card">
        <div className="hub-badge">Nova plataforma oficial</div>

        <div className="hub-brand">
          <span className="hub-brand-hub">Hub</span>
          <span className="hub-brand-arenas">Arenas</span>
        </div>

        <h1 className="hub-title">
          Arena Central agora está no{" "}
          <span className="hub-highlight">Hub Arenas</span>
        </h1>

        <p className="hub-subtitle">
          Reservas, horários disponíveis e novidades da Arena Central agora em
          uma experiência mais rápida, moderna e completa.
        </p>

        <p className="hub-body">
          Para continuar agendando seus horários, acesse a nova plataforma
          oficial da Arena Central no Hub Arenas.
        </p>

        <button className="hub-btn" onClick={handleRedirect}>
          Reservar agora no Hub Arenas
        </button>

        <div className="hub-countdown">
          <div className="hub-countdown-bar">
            <div
              className="hub-countdown-fill"
              style={{ width: `${(count / COUNTDOWN_START) * 100}%` }}
            />
          </div>
          <span className="hub-countdown-text">
            Redirecionamento automático em{" "}
            <span className="hub-countdown-num">{count}s</span>
          </span>
        </div>
      </div>
    </div>
  );
}
